import { j as c } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const r = e((s, i) => /* @__PURE__ */ c.jsx(
  l,
  {
    ref: i,
    ...s,
    image: (a) => /* @__PURE__ */ c.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...a,
        children: [
          /* @__PURE__ */ c.jsxs("g", { clipPath: "url(#clip0_2974_4135)", children: [
            /* @__PURE__ */ c.jsx(
              "mask",
              {
                id: "mask0_2974_4135",
                width: 29,
                height: 32,
                x: 10,
                y: 8,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: /* @__PURE__ */ c.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M14.6 32.42c-.41 0-.75.34-.75.75v6.08c0 .41.34.75.75.75s.75-.34.75-.75v-6.08c0-.42-.33-.75-.75-.75M18.71 21.18h-7.96c-.41 0-.75.34-.75.75s.34.75.75.75h7.96c.41 0 .75-.34.75-.75s-.34-.75-.75-.75M14.6 24.09c-.41 0-.75.34-.75.75v5.17c0 .41.34.75.75.75s.75-.34.75-.75v-5.17c0-.41-.33-.75-.75-.75M14.6 19.91c.41 0 .75-.34.75-.75v-2.43c0-.97.09-1.87.26-2.68.09-.41-.17-.8-.58-.89a.75.75 0 0 0-.89.58c-.19.91-.29 1.92-.29 2.99v2.43c0 .42.34.75.75.75M20.84 8.01C20.7 8 20.56 8 20.42 8c-2.3 0-4.12 1.04-5.27 3.02a.742.742 0 0 0 .65 1.12c.26 0 .51-.13.65-.37.87-1.5 2.21-2.27 3.97-2.27.12 0 .24 0 .35.01.41.03.76-.3.78-.71a.75.75 0 0 0-.71-.79M26.2 17.42c.41 0 .75-.34.75-.75 0-3.76-1.06-6.44-3.08-7.74a.765.765 0 0 0-1.04.22c-.23.34-.12.81.22 1.04 1.98 1.28 2.39 4.23 2.39 6.48.01.41.34.75.76.75M26.2 18.96c-.41 0-.75.34-.75.75v5.72c0 .41.34.75.75.75s.75-.34.75-.75v-5.72c0-.41-.34-.75-.75-.75M26.52 34.31c.4-.1.64-.51.54-.91q-.18-.69-.18-1.47v-3.97c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3.97c0 .64.08 1.26.22 1.84.09.34.39.56.73.56.07 0 .13 0 .19-.02M31.9 38.5c-2.01 0-3.37-.81-4.18-2.49a.75.75 0 0 0-1-.35c-.37.18-.53.63-.35 1C27.42 38.85 29.34 40 31.9 40a.749.749 0 1 0 0-1.5M37.09 35.51a.757.757 0 0 0-1 .37c-.51 1.12-1.22 1.85-2.18 2.26a.75.75 0 0 0 .29 1.44c.1 0 .2-.02.29-.06 1.29-.55 2.29-1.56 2.96-3.01.18-.38.02-.83-.36-1M37.77 29.53c-.41 0-.75.34-.75.75 0 1.28-.09 2.42-.27 3.4-.07.41.2.8.6.87.05.01.09.01.14.01.36 0 .67-.25.74-.62.19-1.06.29-2.3.29-3.67 0-.4-.33-.74-.75-.74"
                  }
                )
              }
            ),
            /* @__PURE__ */ c.jsx("g", { mask: "url(#mask0_2974_4135)", children: /* @__PURE__ */ c.jsx("path", { fill: "currentColor", d: "M-.645-1.801H49.21v50.508H-.645z" }) })
          ] }),
          /* @__PURE__ */ c.jsx("defs", { children: /* @__PURE__ */ c.jsx("clipPath", { id: "clip0_2974_4135", children: /* @__PURE__ */ c.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
r.displayName = "AgencyFinelinesIcon";
export {
  r as AgencyFinelinesIcon,
  r as default
};
//# sourceMappingURL=index.js.map
